import { render, staticRenderFns } from "./Docfile.vue?vue&type=template&id=ca88484e&"
import script from "./Docfile.vue?vue&type=script&lang=js&"
export * from "./Docfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chenzihao/code/workspace/arkui-bus/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca88484e')) {
      api.createRecord('ca88484e', component.options)
    } else {
      api.reload('ca88484e', component.options)
    }
    module.hot.accept("./Docfile.vue?vue&type=template&id=ca88484e&", function () {
      api.rerender('ca88484e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/docfile/Docfile.vue"
export default component.exports